var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-wrap"},[_c('div',{staticClass:"feedback-item gift",on:{"click":_vm.goInvite}},[_c('lottie-player',{staticClass:"gift-animation",attrs:{"src":"https://res.hexiaotu.com/pan/lottie/gift.json","background":"transparent","loop":"","autoplay":""}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hover-tip"},[_c('p',[_vm._v("邀用户，领现金")])])
}]

export { render, staticRenderFns }